module.exports = __webpack_public_path__ + "img/hublot-fusion.c3045e5a.png";